$(document).ready(function() {
  $('summary.header__menu-item').hover(function() {
    $('summary.header__menu-item').attr('aria-expanded', 'false');
    $('details.mega-menu').removeAttr('open');
    $(this).parent().attr('open', '');
    $(this).attr('aria-expanded', 'true');
    $('body').addClass('mega-menu-opened-elevate');
  });
  $('a.header__menu-item').hover(function() {
    $('summary.header__menu-item').attr('aria-expanded', 'false');
    $('details.mega-menu').removeAttr('open');
    $('body').removeClass('mega-menu-opened-elevate');
  });
  $('.overlayheader').hover(function() {
    $('summary.header__menu-item').attr('aria-expanded', 'false');
    $('details.mega-menu').removeAttr('open');
    $('body').removeClass('mega-menu-opened-elevate');
  });
  // Quick & dirty toggle to demonstrate modal toggle behavior
  var checkmodal = localStorage.getItem("modalvisible");
  if (checkmodal != 'true') {
    $('.modal').toggleClass('is-visible');
    localStorage.setItem("modalvisible", "true");
  }
  $('.modal-toggle').on('click', function(e) {
    e.preventDefault();
    if ($(this).hasClass('modal-close')) {
        localStorage.setItem("modalvisible", "true");
    }
    $('.modal').toggleClass('is-visible');
  });

 $('.slider-single').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: false,
   autoplay: true,
  cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)'
 });

 $('.slider-nav')
  .on('init', function(event, slick) {
      $('.slider-nav .slick-slide.slick-current').addClass('is-active');
  })
  .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      focusOnSelect: false,
      infinite: false,
    fade: true,
    speed: 500,
    cssEase: 'linear'
  });

   $('.slider-single').on('afterChange', function(event, slick, currentSlide) {
   	$('.slider-nav').slick('slickGoTo', currentSlide);
   	var currrentNavSlideElem = '.slider-nav .slick-slide[data-slick-index="' + currentSlide + '"]';
   	$('.slider-nav .slick-slide.is-active').removeClass('is-active');
   	$(currrentNavSlideElem).addClass('is-active');
   });
  
   $('.slider-nav').on('click', '.slick-slide', function(event) {
   	event.preventDefault();
   	var goToSingleSlide = $(this).data('slick-index');
  
   	$('.slider-single').slick('slickGoTo', goToSingleSlide);
   });
  
  $('.collection-header-sort').click(function(){
      $(this).toggleClass('active');
      $('.collection-header-sort-row').toggleClass('active');
  });

  $('.booking-form-radio-input').click(function() {
    var loc = $(this).find('input').val();
    var add = $(this).find('textarea').text();
    var sentEmailTo = $(this).find('input').attr('atremail');

    $('.booking-form-store-title').html(loc);
    $('.booking-form-store-info').html(add);
    // var sentEmailTo = '';
    // switch(loc) {
    //   case 'Melbourne':
    //     sentEmailTo = 'cheryl@wpmdigital.com.au';
    //     break;
    //   case 'Sydney':
    //     sentEmailTo = 'geminithinker@gmail.com';
    //     break;
    //   case 'Adelaide':
    //     sentEmailTo = 'adelaide@oscarhunt.com.au';
    //     break;
    //   case 'Brisbane':
    //     sentEmailTo = 'brisbane@oscarhunt.com.au';
    //     break;
    //   case 'Gold Coast':
    //     sentEmailTo = 'goldcoast@oscarhunt.com.au';
    //     break;
    // }
    if($('#globo-formbuilder-99907 #hidden').length > 0) $('#globo-formbuilder-99907 #hidden').val(sentEmailTo);
  });

  $('button.button.bookingform').click(function() {
    $('body .globo-form-id-99907 .globo-form-app .footer button.submit').trigger('click');
  });
  
  $('.template-collection .booking-form-radio-input').click(function() {
    var hn = $(this).attr('chan');
    var v = $('.booking-form-radio').find('input:checked').val();
    console.log(v, hn);
    location.href = hn + '?sort_by=' + v;
  });  

  $('.desktop .product-detail-link-item').click(function() {
    var indx = $(this).attr('indx');
     $('.desktop .product-detail-link-item').removeClass('active');
      $(this).addClass('active');
    $('.desktop .product-detail-contain-item').addClass('hide');
    $('.desktop .product-detail-contain-item[indx="'+indx+'"]').removeClass('hide');
  });


  $('.slider-logo-loop').slick({
    slidesToShow: 1,
    arrows: false,
    fade: false,
    autoplay: true,
    loop: true
  });
  
   $('.slider-logo-loop').on('afterChange', function(event, slick, currentSlide) {
     $('.carousel-indicator-section-img').removeClass('active');
     $('.carousel-indicator-section-img[index="'+currentSlide+'"]').addClass('active');
   });
  
   $(document).on('click', '.carousel-indicator-section-img', function(event) {
   	event.preventDefault();
   	var goToSingleSlide = $(this).attr('index');
  
   	$('.slider-logo-loop').slick('slickGoTo', goToSingleSlide);
   });

  $('.tabbed-btn-link').click(function() {
    var refereces = $(this).attr('refereces');
    $('.tabbed-btn-link').removeClass('active');
    $(this).addClass('active');
    if (refereces == 'all') {
      $('.journal-item').show();
    } else {
      $('.journal-item').hide();
      $('.journal-item[refereces="'+refereces+'"]').show();
    }
  });

	    $('.item-slider').slick({
	      slidesToShow: 4,
	      slidesToScroll: 1,
	      dots: false,
	      arrows: true,
          responsive: [        
           {
              breakpoint: 1199,
              settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
                dots: false,
                arrows: true,
              }
            },{
              breakpoint: 991,
              settings: {
              slidesToShow: 2,
    	      	slidesToScroll: 1,
                dots: false,
                arrows: true,
              }
            },{
              breakpoint: 568,
              settings: {
              slidesToShow: 1,
    	      	slidesToScroll: 1,
                dots: false,
                arrows: true,
                centerMode: true,
                centerPadding: '100px'
              }
            }
          ]    
	    });
  
	    $('.item-slider-shop-the-look').slick({
	      slidesToShow: 3,
	      slidesToScroll: 1,
	      dots: false,
	      arrows: true,
          responsive: [        
           {
              breakpoint: 1199,
              settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
                dots: false,
                arrows: true,
              }
            },{
              breakpoint: 991,
              settings: {
              slidesToShow: 2,
    	      	slidesToScroll: 1,
                dots: false,
                arrows: true,
              }
            },{
              breakpoint: 568,
              settings: {
              slidesToShow: 1,
    	      	slidesToScroll: 1,
                dots: false,
                arrows: true,
                centerMode: true,
                centerPadding: '60px'
              }
            }
          ]    
	    });
  
  $('button.slick-next.slick-arrow').html('<img src="https://cdn.shopify.com/s/files/1/0557/7339/7056/files/arrows.svg?v=1669875664" class="imgnext" />');
  $('button.slick-prev.slick-arrow').html('<img src="https://cdn.shopify.com/s/files/1/0557/7339/7056/files/arrows.svg?v=1669875664" class="imgprev" />');
});
$(window).on('load', function () {
  $('form.g-container p[style="text-align: right;font-size:small;display: block !important;"]').remove();
 });
$(document).ready(function () {
  $('form.g-container p[style="text-align: right;font-size:small;display: block !important;"]').remove();
    setTimeout(() => {
    $(window).on("resize", function (e) {
        checkScreenSize();
    });

    checkScreenSize();
    
    function checkScreenSize(){
        var newWindowWidth = $(window).width();
        if (newWindowWidth < 767) {
           $('.product-recommendations .grid').slick({
            slidesToShow: 1,
            arrows: false,
            centerPadding: '20%',
            centerMode: true,
            fade: false,
            cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)'
           });
        } else {
         $('.product-slider-row').slick({
          slidesToShow: 1,
          arrows: true,
          centerPadding: '24%',
          centerMode: true,
          fade: false,
          cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)'
         });
        }
    }
  },500);

  $('.showrooms-view li.showimg').hover(function() {
    $('.showrooms-view li.showimg').removeClass('active');
    $(this).addClass('active');
  });

  document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#Huratips-Pagination'
    });
  });
});
